// import ApprovalIcon from "@mui/icons-material/Approval";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import CommentIcon from "@mui/icons-material/Comment";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
// import GroupsIcon from "@mui/icons-material/Groups";
import GroupIcon from "@mui/icons-material/Group";
import LightModeIcon from "@mui/icons-material/LightMode";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
import ModeNightIcon from "@mui/icons-material/ModeNight";
import SettingsIcon from "@mui/icons-material/Settings";
import logoDarkTheme from "../assets/darkThemeLogo.png";
// import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
// import BusinessIcon from "@mui/icons-material/Business";
import DescriptionIcon from "@mui/icons-material/Description";
// import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
// import { MdMiscellaneousServices } from "react-icons/md";
import ChecklistIcon from "@mui/icons-material/Checklist";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import MarkChatReadIcon from "@mui/icons-material/MarkChatRead";
import profile from "../assets/avtar.png";

import {
  Avatar,
  Button,
  CircularProgress,
  Collapse,
  Grid,
  List,
  MenuItem,
  Modal,
  Paper,
  useMediaQuery,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/ApaleSarkar.png";
import "../Dashboard/Dashboard.css";
// import avatar from "../assets/avtar.png";
import { isLogin } from "./Auth";

import { Tooltip } from "@mui/material";
import { useThemeMode } from "./Theme";

import { ExpandLess, ExpandMore } from "@mui/icons-material";
import DehazeIcon from "@mui/icons-material/Dehaze";
import PrintIcon from "@mui/icons-material/Print";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { keyframes } from "@mui/system";
import { useState } from "react";
import LoginPageLoader from "../pages/LoginPageLoader";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MarkChatReadOutlinedIcon from "@mui/icons-material/MarkChatReadOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  // background: "linear-gradient(to right, rgb(0, 90, 91), rgb(22, 149, 153))",

  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100%)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      borderRight: "none",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      borderRight: "none",
    },
  }),
}));
const style = {
  position: "absolute",
  top: 15,
  right: 10,
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  marginTop: 7,
};

const rotateIcon = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Styled component with rotation animation
const RotatingIcon = styled(SettingsIcon)(({ theme }) => ({
  animation: `${rotateIcon} 5s linear infinite`,
}));

export default function Dashboard() {
  const [fullscreen, setFullscreen] = React.useState(false);
  const Navigate = useNavigate();
  // const router = useLocation();
  const [open, setOpen] = React.useState(true);
  const [openList, setOpenList] = React.useState(false);
  const [on, setOn] = React.useState(false);
  const { themeMode, LightMode, DarkMode } = useThemeMode();
  const [loading, setLoading] = React.useState(true);
  // const [openCollapse, setOpenCollapse] = React.useState(null);
  const [themestatus, setThemeStatus] = useState(() => {
    const CurrentTheme = localStorage.getItem("Theme");
    return CurrentTheme === "dark" ? false : true;
  });
  const [list, setList] = React.useState(false);
  const location = useLocation();
  const [openCollapse, setOpenCollapse] = React.useState({});

  const [openProcessTransactions, setOpenProcessTransactions] =
    React.useState(false);
  const [userType, setUserType] = useState(null);
  const { roleAccess } = useThemeMode();
  const [loggingOut, setLoggingOut] = useState(false);
  const navigate = useNavigate();
  // const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [userData, setUserData] = React.useState({
    Name: "",
    Phone: "",
    Address: "",
    Email: "",
    Avatar: "",
    _id: "",
  });

  const handleOpenCollapse = (menuId) => {
    setOpenCollapse((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

const allMenus = [
 {
  label: "Dashboards",
  icon: <HomeOutlinedIcon />,
  menuId: "1",                      // parent — no route, just for grouping
  children: [
    { label: "Admin",           path: "home",                    menuId: "1"   },
    { label: "Land Acquisition",path: "LandAcquisition",         menuId: "13"  },
    { label: "Sanjay Gandhi",   path: "SJYGandhiDashboard",      menuId: "14"  },
    {
      label: "Camp Dashboard",
      menuId: "19",            
      children: [
        { label: "WhatsApp Campaign", path: "SendNotificationDashboard", menuId: "19-2" },
        { label: "Email Campaign",    path: "SendEmailDashboard",         menuId: "19-3" },
      ],
    },
  ],
},
  // ── (2) Setup ─────────────────────────────────────────────────────────────
  {
    label: "Setup",
    icon: <SettingsIcon />,
    menuId: "2",
    children: [
      {
        label: "EMail Configuration",
        icon: <EmailIcon />,
        path: "EmailConfiguration",
        menuId: "2",          
      },
    ],
  },
 
  // ── (3) User Creation ─────────────────────────────────────────────────────
  {
    label: "User Creation",
    icon: <PersonOutlineIcon />,
    path: "manage-user",
    menuId: "3",
  },
 
  // ── (12) Role Creation ────────────────────────────────────────────────────
  {
    label: "Role Creation",
    icon: <ManageAccountsOutlinedIcon />,
    path: "RoleCreation",
    menuId: "12",
  },
 
  // ── (5) Documents Master ──────────────────────────────────────────────────
  {
    label: "Documents Master",
    icon: <DescriptionOutlinedIcon />,
    path: "ManageDocPage",
    menuId: "5",
  },
 
  // ── (4) Gazetted Master ───────────────────────────────────────────────────
  {
    label: "Gazetted Master",
    icon: <ChecklistIcon />,
    path: "Gazetted-Master",
    menuId: "4",
  },
 
  // ── (9) Upload Documents ──────────────────────────────────────────────────
  {
    label: "Upload Documents",
    icon: <DriveFolderUploadIcon />,
    path: "Upload-Document",
    menuId: "9",
  },
 
  // ── (10) Sanjay Gandhi ────────────────────────────────────────────────────
  {
    label: "Sanjay Gandhi",
    icon: <MarkChatReadOutlinedIcon />,
    path: "SanjayGandhi",
    menuId: "10",
  },
 
  // ── (11) Rehabilitation ───────────────────────────────────────────────────
  {
    label: "Rehabilitation",
    icon: <CorporateFareIcon />,
    path: "Rehabilitation",
    menuId: "11",
  },
 
  // ── (8) Campaign ──────────────────────────────────────────────────────────
  {
    label: "Campaign",
    icon: <ContactPhoneIcon />,
    menuId: "8",
    children: [
      // (8-17) WhatsApp Campaign
      {
        label: "WhatsApp Campaign",
        icon: <ContactPhoneIcon />,
        path: "SendNotification",
        menuId: "17", 
      },
      // (8-18) Email Campaign
      {
        label: "Email Campaign",
        icon: <MarkEmailUnreadIcon />,
        path: "EmailSetup",
        menuId: "18", 
      },
    ],
  },
  // -------------------------------------------
  //   {
  //      label: "Department",
  //      icon: <BusinessIcon />,
  //      path: "department",
  //       menuId: 6,
  //    },
  //     {
  //      label: "Services",
  //      icon: <SmartphoneIcon />,
  //      path: "Services",
  //      allowed: ["A"],
  //    },
  //     {
  //      label: "Offline Services",
  //      icon: <MiscellaneousServicesIcon />,
  //      path: "OfflineServices",
  //       menuId: 8,
  //    },
  //     {
  //      label: "Online Services",
  //      icon: <MiscellaneousServicesIcon />,
  //      path: "OfflineServices",
  //       menuId: 7,
  //    },
  // ── (5) Reports ───────────────────────────────────────────────────────────
  {
  label: "Reports",
  icon: <LocalPrintshopOutlinedIcon />,
  menuId: "5",
  children: [
    { label: "LandAcquisition", path: "LandAcquistionReport", menuId: "15"   },
    { label: "Sanjay Gandhi",   path: "SJYGandhiReport",      menuId: "16"   },
    {
      label: "Camp Report",
      menuId: "20",
      children: [
        { label: "WhatsApp Campaign", path: "SendMessageReport", menuId: "20-4" },
        { label: "Email Campaign",    path: "EMailSendReport",   menuId: "20-5" },
      ],
    },
  ],
},
];

  const handleOn = () => {
    setOn(true);
  };
  const handleClose = () => {
    setOn(false);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // ------------------Full Screen-------------------
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .then(() => setFullscreen(true));
    } else {
      document.exitFullscreen().then(() => setFullscreen(false));
    }
  };
  // ---------------------------------------

  React.useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    // console.log(JSON.parse(userData));
    setUserData(JSON.parse(userData));
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  //Use for Theme Storage
  React.useEffect(() => {
    const CurrentTheme = localStorage.getItem("Theme");

    if (CurrentTheme === "dark") {
      setThemeStatus(false);
      DarkMode(); // Apply dark mode immediately
    } else {
      setThemeStatus(true);
      LightMode(); // Apply light mode immediately
    }
  }, [DarkMode, LightMode]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [DarkMode, LightMode]);

  const themechange = () => {
    if (themestatus) {
      localStorage.setItem("Theme", "dark");
      DarkMode();
      setThemeStatus(false);
    } else {
      localStorage.setItem("Theme", "light");
      LightMode();
      setThemeStatus(true);
    }
  };

  const handleDrawerOpen = () => {
    setOpen(!open);
    handleClickTransaction();
    // setOpenCollapse(null);
    setOpenCollapse({});
  };

  const handleClickTransaction = () => {
    setOpenProcessTransactions(!openProcessTransactions);
    if (openList) {
      setOpenList(!openList);
    } else if (list) {
      setList(!list);
    }
  };

  const menuId = "primary-search-account-menu";

  React.useEffect(() => {
    if (!isLogin()) {
      Navigate("/");
    }
  });

  const actions = [
    {
      icon: (
        <IconButton
          size="large"
          aria-label="toggle theme"
          color="inherit"
          onClick={themechange}
        >
          {themeMode === "dark" ? <LightModeIcon /> : <ModeNightIcon />}
        </IconButton>
      ),
      name: "Change Theme",
    },

    {
      icon: (
        <IconButton onClick={toggleFullscreen}>
          {fullscreen ? (
            <FullscreenIcon sx={{ color: "white" }} />
          ) : (
            <FullscreenExitIcon sx={{ color: "white" }} />
          )}
        </IconButton>
      ),
      name: "Screen Size",
    },
  ];

  React.useEffect(() => {
    const dataStr = sessionStorage.getItem("userData");
    if (dataStr) {
      try {
        const data = JSON.parse(dataStr);
        setUserType(data.UserType || "U");
      } catch {
        setUserType("U");
      }
    } else {
      setUserType("U");
    }
  }, []);


  // Helper: does this flat menuId (e.g. "19-2") have access given roleAccess?
function checkAccess(menuId, roleAccess) {
  if (!roleAccess || !menuId) return false;
  const menuIdStr = String(menuId);

  if (menuIdStr.includes("-")) {
    const [parentMId, specialMId] = menuIdStr.split("-");
    const parentItem = roleAccess.find(
      (r) => String(r.MenuId) === parentMId && r.IsRead
    );
    if (!parentItem) return false;
    return (
      Array.isArray(parentItem.oSpecialAccess) &&
      parentItem.oSpecialAccess.some((s) => String(s.MenuId) === specialMId)
    );
  }

  // Simple flat MenuId
  return roleAccess.some((r) => String(r.MenuId) === menuIdStr && r.IsRead);
}

function filterMenus(menus, roleAccess) {
  return menus
    .map((menu) => {
      if (menu.children) {
        const filteredChildren = filterMenus(menu.children, roleAccess);
        // Show parent if ANY child is accessible
        if (filteredChildren.length > 0) {
          return { ...menu, children: filteredChildren };
        }
        return null;
      }
      // Leaf node — check access
      return checkAccess(menu.menuId, roleAccess) ? menu : null;
    })
    .filter(Boolean);
}

const visibleMenus = React.useMemo(() => {
  if (!Array.isArray(roleAccess)) return [];
  return filterMenus(allMenus, roleAccess);
}, [roleAccess]);

  // const filterMenus = (menus, allowedMenuIds) => {
  //   return menus
  //     .map((menu) => {
  //       if (menu.children) {
  //         const children = filterMenus(menu.children, allowedMenuIds);

  //         if (children.length > 0) {
  //           return { ...menu, children };
  //         }
  //       }

  //       if (allowedMenuIds.includes(String(menu.menuId))) {
  //         return menu;
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);
  // };

  // const visibleMenus = React.useMemo(() => {
  //   if (!Array.isArray(roleAccess)) return [];

  //   const allowedMenuIds = roleAccess
  //     .filter((item) => item.IsRead)
  //     .map((item) => String(item.MenuId));

  //   return filterMenus(allMenus, allowedMenuIds);
  // }, [roleAccess]);

  // ==============================
  // const renderMenu = (menus, level = 0) => {
  //   return menus.map((menu) => {
  //     const hasChildren =
  //       Array.isArray(menu.children) && menu.children.length > 0;

  //     if (hasChildren) {
  //       return (
  //         <div key={menu.menuId}>
  //           {/* <ListItemButton
  //           onClick={() => handleOpenCollapse(menu.menuId)}
  //           sx={{ pl: 1 + level }}
  //         > */}
  //           <ListItemButton
  //             onClick={() => handleOpenCollapse(menu.menuId)}
  //             sx={{
  //               pl: open ? 1.5 + level : 1,
  //               justifyContent: open ? "initial" : "center",
  //             }}
  //           >
           
  //             <ListItemIcon
  //               sx={{
  //                 minWidth: open ? "45px" : "0px",
  //                 mr: open ? 1 : "auto",
  //                 justifyContent: "center",
  //               }}
  //             >
  //               {menu.icon}
  //             </ListItemIcon>

  //             <ListItemText
  //               primary={menu.label}
                
  //               sx={{
  //                 opacity: open ? 1 : 0,
  //               }}
  //             />
  //             {open &&
  //               (openCollapse[menu.menuId] ? <ExpandLess /> : <ExpandMore />)}
  //           </ListItemButton>

  //           <Collapse
  //             in={openCollapse[menu.menuId]}
  //             timeout="auto"
  //             unmountOnExit
  //           >
  //             <List component="div" disablePadding>
  //               {renderMenu(menu.children, level + 1.4)}
  //             </List>
  //           </Collapse>
  //         </div>
  //       );
  //     }

  //     return (
  //       <Link
  //         key={menu.menuId}
  //         to={`/dashboard/${menu.path}`}
  //         style={{
  //           textDecoration: "none",
  //           color: "inherit",
  //           display: "block",
  //         }}
  //       >
  //         <ListItemButton
  //           sx={{
  //             pl: level,
  //             m: 1,
  //             borderRadius: "8px",
  //           }}
  //         >
  //           <ListItemIcon sx={{ minWidth: "36px" }}>{menu.icon}</ListItemIcon>

  //           <ListItemText
  //             primary={menu.label}
  //             sx={{

  //               display: open ? "block" : "none",
  //             }}
  //           />
  //         </ListItemButton>
  //       </Link>
  //     );
  //   });
  // };
  const renderMenu = (menus, level = 0) => {
  return menus.map((menu) => {
    const hasChildren = Array.isArray(menu.children) && menu.children.length > 0;
    const isActive = menu.path && location.pathname === `/dashboard/${menu.path}`;

    if (hasChildren) {
      return (
        <div key={menu.menuId}>
          <ListItemButton
            onClick={() => handleOpenCollapse(menu.menuId)}
            sx={{
              pl: open ? 1.5 + level * 0.8 : 1,
              py: 0.75,
              mx: 0.75,
              borderRadius: "8px",
              justifyContent: open ? "initial" : "center",
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: open ? "36px" : "0px",
                mr: open ? 1 : "auto",
                justifyContent: "center",
                "& .MuiSvgIcon-root": { fontSize: 20 },
               }}
            >
              {menu.icon}
            </ListItemIcon>
            <ListItemText
              primary={menu.label}
              primaryTypographyProps={{
                fontSize: level === 0 ? 15 : 14,
                fontWeight: level === 0 ? 600 : 500,
              }}
              sx={{ opacity: open ? 1 : 0   }}
            />
            {open && (openCollapse[menu.menuId] ? <ExpandLess sx={{ fontSize: 18 }} /> : <ExpandMore sx={{ fontSize: 18 }} />)}
          </ListItemButton>

          <Collapse in={openCollapse[menu.menuId]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {renderMenu(menu.children, level + 1)}
            </List>
          </Collapse>
        </div>
      );
    }

    return (
      <Link
        key={menu.menuId}
        to={`/dashboard/${menu.path}`}
        style={{ textDecoration: "none", color: "inherit", display: "block" }}
      >
        <ListItemButton
          selected={isActive}
          sx={{
            pl: open ? 1.5 + level * 1.8 : 1,
            py: 0.7,
            mx: 0.75,
            borderRadius: "8px",
            "&.Mui-selected": {
              backgroundColor: "rgba(33,150,243,0.12)",
              color: "#1976d2",
              "& .MuiListItemIcon-root": { color: "#1976d2" },
            },
            "&.Mui-selected:hover": {
              backgroundColor: "rgba(33,150,243,0.18)",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: open ? "40px" : "0px",
              mr: open ? 1 : "auto",
              justifyContent: "center",
              "& .MuiSvgIcon-root": { fontSize: level > 0 ? 18 : 22 },
            }}
          >
            {menu.icon ?? (
              <Box
                sx={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  bgcolor: "currentColor",
                  opacity: 0.5,
                  mx: "auto",
                }}
              />
            )}
          </ListItemIcon>
          <ListItemText
            primary={menu.label}
            primaryTypographyProps={{
               fontSize: level === 0 ? 15 : level === 1 ? 14 : 13.5,
              fontWeight: isActive ? 600 : 400,
            }}
            sx={{ display: open ? "block" : "none" }}
          />
        </ListItemButton>
      </Link>
    );
  });
};
  // =============================
  React.useEffect(() => {
    const findActiveMenu = (menus) => {
      for (let menu of menus) {
        if (menu.path && location.pathname === `/dashboard/${menu.path}`) {
          return menu.menuId;
        }

        if (menu.children) {
          const child = findActiveMenu(menu.children);
          if (child) {
            return menu.menuId;
          }
        }
      }
      return null;
    };

    const activeId = findActiveMenu(visibleMenus);

    if (activeId) {
      setOpenCollapse((prev) => ({
        ...prev,
        [activeId]: true,
      }));
    }
  }, [location.pathname, visibleMenus]);

  //  Show loader or nothing until userType known
  if (!userType) return null;

  return (
    <>
      {loading ? (
        <LoginPageLoader />
      ) : (
        <Box
          sx={{
            display: "flex",
            backgroundColor: (theme) => theme.palette.background.default,
          }}
        >
          <CssBaseline />
          <Modal open={on} onClose={handleClose}>
            <Paper elevation={7} sx={{ ...style, width: 300 }}>
              <center>
                <Grid
                  container
                  item
                  height={"100%"}
                  width={"100%"}
                  justifyContent={"center"}
                  alignItems="center"
                  position="relative"
                >
                  <Avatar
                    alt="Avatar"
                    src={profile}
                    sx={{
                      width: 80,
                      height: 80,
                      position: "absolute",
                      top: "calc(28% - 50px)",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                      border: "1px solid black",
                    }}
                  />
                  <Grid
                    item
                    height={100}
                    width={"100%"}
                    style={{
                      background: "#2196F3",
                      //      background: (theme) =>
                      // theme.palette.customAppbar.appbarcolor || "#2196F3",

                      borderRadius: "3px",
                    }}
                  />
                  <Paper
                    style={{
                      width: "270px",
                      marginTop: -40,
                      borderRadius: 10,
                      position: "relative",
                      marginLeft: 15,
                      marginRight: 15,
                      zIndex: 0,
                    }}
                  >
                    <Grid
                      paddingTop={7}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"start"}
                    >
                      <MenuItem sx={{ fontSize: 13 }}>
                        <b>Name : {userData.Name}</b>
                      </MenuItem>
                      <MenuItem sx={{ fontSize: 13, paddingTop: 0 }}>
                        <b>Mob :</b> {userData.Phone}
                      </MenuItem>
                      <MenuItem sx={{ fontSize: 13, paddingTop: 0 }}>
                        <b>Email :</b> {userData.Email}
                      </MenuItem>
                      <MenuItem sx={{ fontSize: 13, paddingTop: 0 }}>
                        <b>Gaz Officer :</b> {userData.GazOfficer}
                      </MenuItem>
                    </Grid>

                    <Grid
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      paddingBottom={2}
                    >
                      <Button
                        onClick={() => {
                          setLoggingOut(true);

                          setTimeout(() => {
                            sessionStorage.clear();
                            Navigate("/");
                          }, 500);
                        }}
                        disabled={loggingOut}
                        sx={{
                          boxShadow: 4,
                          borderRadius: 2,
                          background: "#2196F3",
                          color: "white",
                          fontSize: 11,
                          fontWeight: "bold",
                          minWidth: 100,
                          transition: "all 0.3s ease",

                          "&:hover": {
                            background: "#1976d2",
                          },
                        }}
                      >
                        {loggingOut ? (
                          <CircularProgress size={18} sx={{ color: "white" }} />
                        ) : (
                          "Log Out"
                        )}
                      </Button>
                    </Grid>
                  </Paper>
                </Grid>
              </center>
            </Paper>
          </Modal>

          <AppBar position="fixed" open={open}>
            <Toolbar
              sx={{
                width: "100vw",

                backgroundColor: (theme) =>
                  theme.palette.customAppbar?.appbarcolor || "defaultColor",
                display: "flex",
              }}
              //               sx={{
              //   minHeight: 48, // default is 64 (desktop)
              //   '@media (min-width:600px)': {
              //     minHeight: 48, // for larger screens also
              //   },
              //   width: "100vw",
              //   backgroundColor: (theme) =>
              //     theme.palette.customAppbar?.appbarcolor || "defaultColor",
              //   display: "flex",
              // }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: 5,
                  color: "white",
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant="h6"
                noWrap
                component="div"
                textAlign="center"
                width="100%"
                className="flash-animation"
                sx={{ color: "white", letterSpacing: "1.2px" }}
              >
                Ahilyanagar Samwad Setu
              </Typography>

              <SpeedDial
                ariaLabel="SpeedDial"
                direction="left"
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 90,
                  "& .MuiFab-root": {
                    boxShadow: "none !important",
                    backgroundColor: "transparent !important",
                  },
                }}
                icon={<RotatingIcon />}
                FabProps={{
                  sx: {
                    background: "#2196F3",
                    color: "white",
                    "&:hover": {
                      background: "#2196F3",
                    },
                  },
                }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    sx={{
                      background: "#2196F3",
                      color: "white",
                      "&:hover": {
                        background: "#bac7d3ff",
                      },
                    }}
                  />
                ))}
              </SpeedDial>

              <Tooltip title={userData.Username}>
                <IconButton
                  size="small"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleOn}
                  color="inherit"
                >
                  <Avatar
                    src={profile}
                    alt="User Logo"
                    sx={{ width: 40, height: 41 }}
                  />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>

          <Drawer variant="permanent" open={open} PaperProps={{ elevation: 2 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: 8,
              }}
            >
              <IconButton onClick={handleDrawerOpen}>
                <ChevronLeftIcon />
              </IconButton>
            </div>

            <Grid style={{ height: 90 }}>
              <img
                src={themestatus ? logo : logoDarkTheme}
                alt="logo"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  paddingTop: 10,
                }}
              />
            </Grid>

            <Grid
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                "&:hover": { overflowY: "auto", scrollbarWidth: "thin" },
              }}
            >
              {renderMenu(visibleMenus)}
            </Grid>
          </Drawer>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,

              ...(open && { width: `calc(100% - ${drawerWidth}px)` }),

              ...(!open && {
                width: theme.spacing(7),
                [theme.breakpoints.up("sm")]: {
                  width: theme.spacing(9),
                },
              }),
            }}
          >
            <DrawerHeader />
            <Outlet />
          </Box>
        </Box>
      )}
    </>
  );
}
